import { useState } from 'react';
import { FolderSelector } from '@/pages/Home/components/FolderSelector';
import { MoveAudioToFolder } from '@/service/folder';
import { Dialog } from '@/components/Dialog';
import { cn } from '@/utils';
import { useRefreshData } from './useRefreshData';
import { useLeftPanelDrawer, useSongDetailDrawer } from '@/state/drawer-store';

const useMoveTrackToFolderDialog = ({ id }: { id: string }) => {
  const { refreshAudioInList, refreshSongDetail, refreshFolders, refreshCatalogOverview } = useRefreshData();
  const { setIsDrawerShow: setIsLeftPanelShow } = useLeftPanelDrawer();
  const { setIsDrawerShow: setIsDetailShow } = useSongDetailDrawer();

  return () => {
    Dialog.info({
      closeClassName: 'left-auto right-4 !p-0 rounded-[4px] ',
      dialogContentClassName: 'bg-jen-content-primary-contrast h-[440px]',
      title: 'Move track to folder',
      contentJSX: ({ onClose }) => {
        const [selectedFolderId, onChangeSelectedFolderId] = useState<number>();
        return (
          <div>
            <FolderSelector
              onCreateFolder={() => {
                setIsDetailShow(false);
                setIsLeftPanelShow(true);
                onClose();
              }}
              className="h-[272px] overflow-y-scroll"
              onchange={(id) => onChangeSelectedFolderId(id)}
            />
            <div
              onClick={async () => {
                if (selectedFolderId) {
                  await MoveAudioToFolder({
                    audioId: id,
                    folderId: selectedFolderId,
                  });
                  refreshSongDetail();
                  refreshFolders();
                  refreshCatalogOverview();
                  refreshAudioInList({ id });
                  onClose();
                }
              }}
              className="border-jen-border border-t absolute left-0 bottom-0 p-jen-spacing-16 w-full cursor-pointer"
            >
              <div
                className={cn(
                  'text-jen-content-primary-contrast text-[16px] rounded-jen-spacing-8 h-[40px] w-full flex justify-center items-center bg-jen-interactive-primary ',
                  {
                    'bg-[#ffcebe] cursor-not-allowed': !selectedFolderId,
                  },
                )}
              >
                move
              </div>
            </div>
          </div>
        );
      },
    });
  };
};

export default useMoveTrackToFolderDialog;
